/**
 * @file コンポーネント：フル動画ページ決済情報ポップアップ ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// 関数読み込み
import { fnHandleApiErrors, fnHandleApiSuccess } from "~/src/functions/common";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const PopupPayment = (props) => {
    /**
     * 読み込み時の処理
     */
    const [price, setPrice] = useState(null); // 価格
    const [thumbnail, setThumbnail] = useState(null); // 症例サムネイル
    const [title, setTitle] = useState(null); // 症例タイトル
    useEffect(() => {
        // 決済情報の取得
        const api = "/api/sales/product/preview/" + props.productId;
        fetch(api)
            .then(fnHandleApiErrors)
            .then(fnHandleApiSuccess)
            .then((result) => {
                if (result !== null) {
                    setPrice(result.unitAmount);
                    setThumbnail(result.imageUrl);
                    setTitle(result.operationTitle);
                }
            })
            .catch((error) => {
                console.error(error);
            });
        // 利用規約モーダルを開く処理を追加（ReactDOMServerを使用してレンダリングしているため、onClick等React実装ができない）
        const timerId = setInterval(() => {
            const anchorTerms = document.getElementById("js-anchor-terms");
            if (anchorTerms !== null) {
                anchorTerms.addEventListener("click", (e) => {
                    e.preventDefault();
                    props.setIsOpenModalTerms(true);
                });
                clearInterval(timerId);
            }
        }, 100);
    }, []);

    /**
     * 決済へ進むボタンクリック時の処理
     */
    const refForm = useRef(null);
    const fnOnClickPayment = (e) => {
        // クリックデフォルト処理をキャンセル
        e.preventDefault();
        // 決済フォームをsubmit
        const form = refForm.current;
        form.action = "/api/checkout/Product/session/" + props.productId;
        form.method = "GET";
        form.submit();
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnOnClickPayment={fnOnClickPayment}
            price={price}
            refForm={refForm}
            thumbnail={thumbnail}
            title={title}
        />
    );
};
